import { ReadPayroll } from "@/types/payroll";

export const generatePayrollDisplayName = (
  payroll?: Pick<ReadPayroll, "payroll_type" | "period">,
) => {
  if (!payroll) {
    return "...";
  }
  return `${payroll.payroll_type} - ${payroll.period}`;
};
